/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface TextValueListDto
 */
export interface TextValueListDto {
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    setupParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TextValueListDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TextValueListDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TextValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof TextValueListDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<string>}
     * @memberof TextValueListDto
     */
    values?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    $type?: TextValueListDtoTypeEnum;
}


/**
 * @export
 */
export const TextValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersTextValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TextValueListDtoTypeEnum = typeof TextValueListDtoTypeEnum[keyof typeof TextValueListDtoTypeEnum];



/**
 * Check if a given object implements the TextValueListDto interface.
 */
export function instanceOfTextValueListDto(value?: unknown): value is TextValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TextValueListDtoTypeEnum)[0];
}

export function TextValueListDtoFromJSON(json: any): TextValueListDto {
    return TextValueListDtoFromJSONTyped(json, false);
}

export function TextValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextValueListDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'setupParameterId': json['setupParameterId'] == null ? undefined : json['setupParameterId'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'name': json['name'] == null ? undefined : json['name'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isReadonly': json['isReadonly'] == null ? undefined : json['isReadonly'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'values': json['values'] == null ? undefined : json['values'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TextValueListDtoToJSON(value?: TextValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'setupParameterId': value['setupParameterId'],
        'groupId': value['groupId'],
        'name': value['name'],
        'isRequired': value['isRequired'],
        'isReadonly': value['isReadonly'],
        'isEnabled': value['isEnabled'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'values': value['values'],
        '$type': value['$type'],
    });
}

